<section class="hosted-bank-form" aria-label="Bank account details">

    <p *ngIf="!fluidPayFormFinishedLoading && !errorMessage" role="status">
        Loading bank account fields...
    </p>

    <p *ngIf="errorMessage" role="alert">
        {{ errorMessage }}
    </p>

    <div #container [id]="containerID"></div>

</section>